import { action } from 'easy-peasy';
import { IActionClearHospitalDetails } from '../types';

const clearHospitalDetails: IActionClearHospitalDetails = action(state => {
  state.details = null;
});

export default clearHospitalDetails;
